<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { businessId, reviewUrl, unloadTrustpilot, loadTrustpilot } from "./config";

  export let height = "28px";
  export let width = "100%";
  export let theme = "light";
  export let locale = "en-GB";
  export let className = "";

  // Create the script element
  let script: HTMLScriptElement;
  onMount(() => loadTrustpilot(script));
  onDestroy(() => unloadTrustpilot(script));
</script>

<!-- TrustBox widget - Horizontal -->
<div
  class={["trustpilot-widget", className].filter(v => v).join(" ")}
  data-locale={locale}
  data-template-id="5406e65db0d04a09e042d5fc"
  data-businessunit-id={businessId}
  data-style-height={height}
  data-style-width={width}
  data-theme={theme}
>
  <a href={reviewUrl} target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->
